import { render, staticRenderFns } from "./userGuidance.vue?vue&type=template&id=a16dba0c&scoped=true"
import script from "./userGuidance.vue?vue&type=script&lang=js"
export * from "./userGuidance.vue?vue&type=script&lang=js"
import style0 from "./userGuidance.vue?vue&type=style&index=0&id=a16dba0c&prod&lang=scss"
import style1 from "./userGuidance.vue?vue&type=style&index=1&id=a16dba0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16dba0c",
  null
  
)

export default component.exports